<template>
  <div class="vchy-filters__wrapper" v-if="filterList.length">
    <button class="clear-btn text-button --desktop" v-if="
      (selectedFilters.length > 1 && this.searchParams !== null) ||
      (selectedFilters.length && this.searchParams === null)
    " @click="clearFilters">
      {{ clearBtnTitle }}
    </button>
    <div role="group" :aria-labelledby="filter.type" v-for="filter in filterList" :key="filter.type">
      <details class="vchy-details" v-vch-accordion v-if="filter.tags.length">
        <summary class="vchy-details__summary" aria-expanded="false" :id="[filter.type]">
          <span>{{ filter.header }}</span>
          <svg class="vchy-details__toggle" aria-hidden="true" width="24" height="24">
            <use href="/assets/sprite/icons.svg#arrow-close"></use>
          </svg>
        </summary>
        <div class="vchy-details__contents" tabindex="-1">
          <ul class="vchy-tags__wrapper" data-tag-wrapper id="vchy-tags__wrapper">
            <li v-for="facet in filter.tags" :key="facet.id" class="vchy-tags__item">
              <input ref="checkbox" type="checkbox" v-model="facet.selected" :id="facet.id" :name="facet.label"
                :value="facet.selected" :checked="facet.selected" :disabled="facet.disabled || loading"
                @focus="lastFocusedFacetId = facet.id"
                @change="onInputChange(facet, filter)"
                @keydown.enter.prevent="$event.target.click()" />
              <label :class="{
                '-selected': facet.selected,
                '-disabled': facet.disabled,
              }" :for="facet.id">
                <span class="vchy-tags__tag"> {{ facet.label }}</span>
              </label>
            </li>
          </ul>
        </div>
      </details>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { pushEvent } from 'Utils/datalayer';

export default {
  name: 'VchProductFilters',

  props: {
    filters: {
      type: String,
      required: true,
    },
    clearBtnTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedFilters: [],
      filterList: [],
      busName: 'item-grid',
      loading: false,
      searchParams: '',
      rangeStr: '',
      lastFocusedFacetId: null,
    };
  },
  watch: {
    loading(isLoading) {
      if (!isLoading) {
        this.restoreCheckboxFocus();
      }
    },
  },
  created() {
    this.updateFilterDisplay(JSON.parse(this.filters));
  },
  mounted() {
    eventBus.$on(`${this.busName}:clearFilters`, this.clearFilters);
    eventBus.$on(`${this.busName}:update-filters`, this.updateFilterDisplay);
    eventBus.$on(`${this.busName}:filters`, this.syncSelectedFilters);
    eventBus.$on(`${this.busName}:loadingState`, (isLoading) => {
      this.loading = isLoading;
    });

    const url = new URL(window.location);
    this.searchParams = url.searchParams.get('range');
    if (this.searchParams !== null) {
      let rangeAccordianEle = document.getElementById('rangeName');
      if (rangeAccordianEle !== null) {
        rangeAccordianEle.click();
      }
      const str = this.searchParams;
      this.rangeStr = str.replace(/-/g, ' ');
      let rangeEle = document.getElementById(this.rangeStr);
      if (rangeEle !== null) {
        rangeEle.click();
      } else {
        let redirectUrl = window.location.origin + window.location.pathname;
        window.location = redirectUrl;
      }
    }
  },
  beforeDestroy() {
    eventBus.$off(`${this.busName}:clearFilters`, this.clearFilters);
    eventBus.$off(`${this.busName}:update-filters`, this.updateFilterDisplay);
    eventBus.$off(`${this.busName}:filters`, this.syncSelectedFilters);
    eventBus.$off(`${this.busName}:loadingState`);
  },
  methods: {
    setSelectedProp() {
      this.filterList.forEach((filter) => {
        filter.tags.forEach((cb) => {
          cb.selected =
            this.selectedFilters.filter((sf) => sf.value === cb.id).length > 0;
        });
        if (filter.header == 'Range') {
          filter.tags.forEach((cb) => {
            if (cb.id == this.rangeStr) {
              cb.disabled = true;
            }
          });
        }
      });
    },
    formatInputValue(val) {
      if (!val) {
        return null;
      }
      if (typeof val === 'string') {
        return JSON.parse(val);
      } else {
        return JSON.stringify(val);
      }
    },
    restoreCheckboxFocus() {
      const facetId = this.lastFocusedFacetId;
      if (!facetId) {
        return;
      }
      this.$nextTick(() => {
        const refs = this.$refs.checkbox;
        const checkboxes = Array.isArray(refs) ? refs : refs ? [refs] : [];
        let checkbox = checkboxes.find((el) => el && el.id === facetId);
        if (!checkbox && this.$el && this.$el.querySelectorAll) {
          const inputs = this.$el.querySelectorAll('input[type="checkbox"]');
          checkbox = Array.prototype.find.call(
            inputs,
            (el) => el.id === facetId
          );
        }
        if (checkbox && !checkbox.disabled) {
          checkbox.focus();
        }
      });
    },
    onInputChange(facet, filter) {
      this.lastFocusedFacetId = facet.id;
      const data = { type: filter.type, value: facet.id };
      const filterName = facet.label.toLowerCase();
      const filterTitle = filter.header;
      if (facet.selected) {
        this.selectedFilters.push(data);
        if (window.innerWidth > 1023) {
          pushEvent({
            event: 'uaevent',
            ecommerce: 'undefined',
            eventCategory: 'product selector page',
            eventAction: 'filter',
            eventLabel: filterTitle,
            event_name: 'use_filters',
            filter_type: 'filter',
            filter_value: `${filterTitle.toLowerCase()}::${filterName}`,
          });
        }
      } else {
        this.selectedFilters = this.selectedFilters.filter((inputVal) => {
          if (inputVal.value !== data.value) {
            return data;
          }
        });
      }
      if (window.innerWidth > 1023) { //for desktop
        this.viewResult();
      } else {
        this.viewResultMobile();
      }
    },
    viewResult() {
      this.$emit('range-select', this.searchParams);
      eventBus.$emit(`${this.busName}:filters-selected`);
      eventBus.$emit(`${this.busName}:filters`, this.selectedFilters);
    },
    viewResultMobile() {
      this.$emit('range-select', this.searchParams);
      this.$emit('filters-selected', this.selectedFilters);
    },
    syncSelectedFilters(currentFilterSelections) {
      this.selectedFilters = currentFilterSelections;
    },
    clearFilters(isModalOpen = false) {
      if (this.searchParams === null) {
        this.selectedFilters = [];
      } else {
        let result = this.selectedFilters.filter(function (ele, i) {
          return ele.type == 'rangeName';
        });
        this.selectedFilters = [];
        this.selectedFilters.push(result[0]);
      }
      this.setSelectedProp();
      // when in desktop then update product impression & product grid
      if (window.innerWidth > 1023) {
        eventBus.$emit(`${this.busName}:filters`, this.selectedFilters);
      } else {  // mobile view restrict update tagging untill modal closed
        this.$emit('filters-selected', this.selectedFilters);
        if (!isModalOpen) {
          eventBus.$emit(`${this.busName}:filters`, this.selectedFilters);
        }
      }
    },
    updateFilterDisplay(filterData) {
      const activeEl = document.activeElement;
      if (
        this.$el &&
        typeof this.$el.contains === 'function' &&
        activeEl &&
        this.$el.contains(activeEl) &&
        activeEl.matches &&
        activeEl.matches('input[type="checkbox"]')
      ) {
        this.lastFocusedFacetId = activeEl.id;
      }
      this.filterList = filterData;
      this.setSelectedProp();
      this.restoreCheckboxFocus();
    },
  },
};
</script>
<style lang="scss" src="./product-filters.scss"></style>
